/**
 * Commerce Model Foundation — Step 1 of the multi-model expansion.
 *
 * `commerce_model` lives on the `stores` table (one seller may own several
 * stores with different archetypes). It is intentionally distinct from
 * `business_model` (which describes *sourcing*: dropshipping / reselling /
 * manufacturing / …). Do not conflate the two.
 */
export type CommerceModel = "cod" | "dropshipping" | "digital" | "hybrid";

export const COMMERCE_MODEL_VALUES: readonly CommerceModel[] = [
  "cod",
  "dropshipping",
  "digital",
  "hybrid",
] as const;

/** Default archetype for legacy stores and any unknown value. */
export const DEFAULT_COMMERCE_MODEL: CommerceModel = "cod";

export function isCommerceModel(v: unknown): v is CommerceModel {
  return typeof v === "string" && (COMMERCE_MODEL_VALUES as readonly string[]).includes(v);
}

export function normalizeCommerceModel(v: unknown): CommerceModel {
  return isCommerceModel(v) ? v : DEFAULT_COMMERCE_MODEL;
}

/** Localstorage key used to defer commerce_model when no store exists yet. */
export const PENDING_COMMERCE_MODEL_KEY = "vazoul:pending_commerce_model";
